import * as React from 'react';

import { View } from '@/core';
import Component from './Icon';
import { IconProps, IconNameType } from './model';

export type { IconProps, IconNameType };

/**
 * WBIcon component from the ciao-icons inventory, rendered as text.
 */
export const WBIcon: React.FC<IconProps> = ({ color = 'black', name, size = 20, style }) => {
	if (!name) {
		return null;
	}

	return (
		<View style={style}>
			<Component color={color} name={name} size={size} />
		</View>
	);
};
